<ng-container [formGroup]="physicianFormGroup">

  <!-- physician search -->
  <div class="search-engine-container" *ngIf="this.formGroupParent !== 'ConditionHospital'">

    <!-- item -->
    <div class="row">
      <div class="col-12 col-md-4">
        <p>Physician Search Engine</p>
      </div>
    </div>
    <!-- /item -->

    <!-- item -->
    <div class="row">

      <!-- sub-item -->
      <div class="col-12 col-md-4">
        <div class="form-group">
          <div class="select-wrapper">
            <label for="stateFilter" class="visually-hidden">State Filter</label>
            <select id="stateFilter" (change)="onStateChange($event)" class="form-control" id="StateFilter" formControlName="StateFilter" tabindex="0">
              <option [ngValue]="null" label="State Filter" disabled selected="selected"></option>
              <option *ngFor="let opt of states" [value]="opt.key">
                {{ opt.value }}
              </option>
            </select>
          </div>
        </div>
      </div>
      <!-- /sub-item -->

      <!-- sub-item -->
      <div class="col-12 col-md-8">
        <div class="form-group">

          <div *ngIf="processing" class="text-muted small animate-show tt-indicator">
            <i class="fas fa-circle-notch fa-spin"></i> searching...
          </div>

          <div *ngIf="!processing && err" class="error-message small tt-error">
            <p>An error occurred while searching. Click to <a (click)="searchForPhysicians()" style="color: black;">here</a> to retry.</p>
          </div>

          <div class="search-container">
            <div class="search-icon-container search-icon-container-left">
              <span class="fa fa-search physician-search" aria-hidden="true"></span>
            </div>
            <label for="search" class="visually-hidden">Search</label>
            <input id="search" type="text" [(ngModel)]="queryString" (ngModelChange)="SearchInputUpdate.next($event)" class="form-control search-input" formControlName="Search" placeholder="Last Name" tabindex="0">
          </div>

          <error-messages [form]="parent" [field]="formGroupParent + '.Search'" skipFeedback="true"></error-messages>

        </div>
      </div>
      <!-- /sub-item -->
    </div>
    <!-- /item -->

    <!-- item -->
    <div id="physician-list" *ngIf="showList && PhysiciansDataArray.length >= 1">
      <mat-form-field appearance="fill">
        <mat-label>Physicians</mat-label>
        <mat-select>
          <mat-option *ngFor="let Physician of PhysiciansDataArray" class="physician-list-item" (click)="setFormValues(Physician)" onkeypress="setFormValues(Physician)">
            {{Physician.first_name}} {{Physician.last_name}} <span *ngIf="Physician.alias">(Formerly: {{Physician.alias}})</span> | {{Physician.street}} {{Physician.city}}, {{Physician.state}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <!-- /item -->
  </div>
  <!-- /physician search -->

  <!-- item -->
  <div class="row">
    <div class="col">
      <div class="form-group">
        <label for="physicianName" class="visually-hidden">Name</label>
        <input id="physicianName" type="text" class="form-control" formControlName="Name" placeholder="Name" tabindex="0" [ngClass]="{'input-required': isRequired}">
        <error-messages [form]="parent" [field]="formGroupParent + '.Name'" skipFeedback="true"></error-messages>
      </div>
    </div>
  </div>
  <!-- /item -->

  <!-- item -->
  <div class="row">
    <div class="col">
      <div class="form-group">
        <label for="physicianPhone" class="visually-hidden">Phone</label>
        <input id="physicianPhone" [cleave]="mask" type="tel" maxlength="12" class="form-control" formControlName="Phone" placeholder="Phone" tabindex="0" [ngClass]="{'input-required': isRequired}">
        <error-messages [form]="parent" [field]="formGroupParent + '.Phone'" skipFeedback="true"></error-messages>
      </div>
    </div>
  </div>
  <!-- /item -->

    <!-- autocomplete -->
  <div class="row" *ngIf="this.formGroupParent === 'ConditionHospital'">
    <div class="col-12">
      <address-autocomplete (onSelectAddress)="updateAddress($event)"></address-autocomplete>
    </div>
  </div><!-- /autocomplete -->

 <!-- item -->
  <div class="row">
    <div class="col-12">
      <div class="form-group">
        <label for="physicianStreet" class="visually-hidden">Street Address</label>
        <input id="physicianStreet" type="text" class="form-control" formControlName="Street" maxlength="225" placeholder="Street Address" tabindex="0" [ngClass]="{'input-required': isRequired}">
        <error-messages [form]="parent" [field]="formGroupParent + '.Street'" skipFeedback="true"></error-messages>
      </div>
    </div>
  </div>
  <!-- /item -->

  <!-- item -->
  <div class="row">

    <!-- sub-item -->
    <div class="col-12 col-md-4">
      <div class="form-group">
        <label for="physicianStreet2" class="visually-hidden">Apartment/Unit</label>
        <input id="physicianStreet2" type="text" class="form-control" formControlName="Street2" maxlength="225" placeholder="Apartment/Unit" tabindex="0">
        <error-messages [form]="parent" [field]="formGroupParent + '.Street2'" skipFeedback="true"></error-messages>
      </div>
    </div>
    <!-- /sub-item -->

    <!-- sub-item -->
    <div class="col-12 col-md-8">
      <div class="form-group">
        <label for="physicianCity" class="visually-hidden">City</label>
        <input id="physicianCity" type="text" class="form-control" formControlName="City" maxlength="30" placeholder="City" tabindex="0" [ngClass]="{'input-required': isRequired}">
        <error-messages [form]="parent" [field]="formGroupParent + '.City'" skipFeedback="true"></error-messages>
      </div>
    </div>
    <!-- /sub-item -->

  </div>
  <!-- /item -->

  <!-- item -->
  <div class="row">
    <!-- sub-item -->
    <div class="col-12 col-md-4">
      <div class="form-group">
        <div class="select-wrapper">
          <label for="physicianState" class="visually-hidden">State</label>
          <select id="physicianState" class="form-control" id="State" formControlName="State" tabindex="0" [ngClass]="{'input-required': isRequired}">
            <option [ngValue]="null" label="State" disabled selected="selected"></option>
            <option *ngFor="let opt of states" [value]="opt.key">
              {{ opt.value }}
            </option>
          </select>
        </div>
        <error-messages [form]="parent" [field]="formGroupParent + '.State'" skipFeedback="true"></error-messages>
      </div>
    </div>
    <!-- /sub-item -->

    <!-- sub-item -->
    <div class="col-12 col-md-8">
      <div class="form-group">
        <label for="physicianZip" class="visually-hidden">Zip</label>
        <input id="physicianZip" type="text" class="form-control" formControlName="Zip" placeholder="Zip Code" oninput="this.value=this.value ? this.value.replace(/(?![0-9])./gmi,'') : null" maxlength="5" tabindex="0" [ngClass]="{'input-required': isRequired}">
        <error-messages [form]="parent" [field]="formGroupParent + '.Zip'" skipFeedback="true">
        </error-messages>
      </div>
    </div>
    <!-- /sub-item -->
  </div>
  <!-- /item -->

</ng-container>
